var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYellowStarBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F8B24F",
  d: "m22 11-2.44-2.79.34-3.69-3.61-.82L14.4.5 11 1.96 7.6.5 5.71 3.69 2.1 4.5l.34 3.7L0 11l2.44 2.79-.34 3.7 3.61.82L7.6 21.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69zM8.38 15.01 6 12.61a.996.996 0 0 1 0-1.41l.07-.07c.39-.39 1.03-.39 1.42 0l1.61 1.62 5.15-5.16c.39-.39 1.03-.39 1.42 0l.07.07c.39.39.39 1.02 0 1.41l-5.92 5.94c-.41.39-1.04.39-1.44 0"
})));
export default SvgYellowStarBadge;